(function($) {
  $('.product-gallery-slider').slick({
    fade: false,
    arrows: false,
    dots: true,
  });
})($);